<template>
	<div>
		<chart :options="chart_options"></chart>
	</div>
</template>

<script>
    import ECharts from 'vue-echarts'
    import 'echarts/lib/chart/bar'
    import 'echarts/lib/chart/pie'
    import 'echarts/lib/component/legend'
    import 'echarts/lib/component/tooltip'

    export default {
        components: {
            'chart': ECharts
        },
        props: {
            chart_options: {
                type: Object
            }
        },
    }
</script>

<style>
	/**
	 * The default size is 600px×400px, for responsive charts
	 * you may need to set percentage values as follows (also
	 * don't forget to provide a size for the container).
	 */
	.echarts {
		width: 100%;
		height: 550px;
	}
</style>